export default "__VITE_ASSET__DmNOCf$X__"